var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3223 6L14.6364 9.16V9C14.6364 8.20435 14.3059 7.44129 13.7177 6.87868C13.1296 6.31607 12.3318 6 11.5 6H11.3223ZM6.82682 6.8L8.44727 8.35C8.395 8.56 8.36364 8.77 8.36364 9C8.36364 9.79565 8.69407 10.5587 9.28226 11.1213C9.87044 11.6839 10.6682 12 11.5 12C11.73 12 11.96 11.97 12.1795 11.92L13.8 13.47C13.0995 13.8 12.3259 14 11.5 14C10.1136 14 8.78406 13.4732 7.80376 12.5355C6.82346 11.5979 6.27273 10.3261 6.27273 9C6.27273 8.21 6.48182 7.47 6.82682 6.8ZM1.04545 1.27L3.42909 3.55L3.89955 4C2.17455 5.3 0.815454 7 0 9C1.80864 13.39 6.27273 16.5 11.5 16.5C13.1205 16.5 14.6677 16.2 16.0791 15.66L16.5286 16.08L19.5814 19L20.9091 17.73L2.37318 0M11.5 4C12.8864 4 14.2159 4.52678 15.1962 5.46447C16.1765 6.40215 16.7273 7.67392 16.7273 9C16.7273 9.64 16.5914 10.26 16.3509 10.82L19.4141 13.75C20.9823 12.5 22.2368 10.86 23 9C21.1914 4.61 16.7273 1.5 11.5 1.5C10.0364 1.5 8.63545 1.75 7.31818 2.2L9.58682 4.35C10.1827 4.13 10.8205 4 11.5 4Z",
    fill: "#ABD6D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconView);
export default __webpack_public_path__ + "static/media/icon-view.9e4ca1819c5dff0a31ab4b878a138fce.svg";
export { ForwardRef as ReactComponent };